import { header } from './header';
import { salesforceLead } from './salesforce-lead';
import { newsletterSignup } from './newsletter-signup';

const components = [header, salesforceLead, newsletterSignup];

export default components;
